"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _lodash = require("lodash");
var _reactEllipsisText = _interopRequireDefault(require("react-ellipsis-text"));
var _overlay = _interopRequireDefault(require("./overlay"));
require("./SearchBar.scss");
var _screenSizes = _interopRequireDefault(require("../../../core/utils/screenSizes"));
var _Select = _interopRequireDefault(require("../../Atoms/Select"));
var _ImageThumbnails = _interopRequireDefault(require("../ImageThumbnails"));
var _HeaderTopResults = _interopRequireDefault(require("../HeaderTopResults"));
var _common = require("../../../core/utils/common");
var _AutoSuggestWrapper = _interopRequireDefault(require("./AutoSuggestWrapper"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var cssOverridesForSearchBar = 'cmp-search-bar__auto-suggest--open';
var cssOverridesForSearchBody = 'cmp-search-body__auto-suggest--open';
var searchBarFocusClassName = 'cmp-search-bar--focus';
var searchNoScrollClassName = 'no-scroll';
var REASON_SUGGESTIONS_CLEARED = 'clear-suggestion';
var SUGGESTION = 'suggestion';
var FACET = 'facet';
var MAX_FACETS = 2;
var MAX_TOP_RESULTS = 5;
var SHOP = 'Shop';
var ALL = 'All';
var SEARCH_TYPE = {
  RECENTLY_SEARCHED: 'Recently_Searched',
  SEARCH_SUGGESIONS: 'Search_Suggesions',
  SKU_FAMILY: 'SKU_Family',
  TOP_RESULTS: 'Top_Results',
  SEARCH_ICON: 'Search_IconClick'
};
var SEARCH_LINK_TYPE = {
  LINK: 'link',
  ICON: 'icon',
  IMAGE: 'image'
};
var SearchBar = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(SearchBar, _Component);
  function SearchBar(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.getSearchValue = function () {
      var _this$state = _this.state,
        onSearchRequest = _this$state.onSearchRequest,
        value = _this$state.value,
        selectedCategory = _this$state.selectedCategory;
      var _this$state$parameter = _this.state.parameterDefaults,
        mostRecent = _this$state$parameter.mostRecent,
        rows = _this$state$parameter.rows,
        isoCode = _this$state$parameter.isoCode;
      _this.setState({
        searchRequested: true
      });
      onSearchRequest({
        term: value,
        rows: rows,
        sort: mostRecent,
        isoCode: isoCode,
        category: selectedCategory
      });
    };
    _this.componentDidMount = function () {
      _this.inputElement = document.querySelector('.cmp-search-bar .react-autosuggest__container .react-autosuggest__input'); // this is for desktop

      window.addEventListener('resize', _this.handleWindowResizeDebounce); // this is for iPad orientation

      window.addEventListener('orientationchange', _this.handleViewChange); // this is for mobile devices

      window.addEventListener('deviceorientation', _this.handleViewChange);
    };
    _this.transformSuggestionObject = function (suggestions, recentlySearched) {
      var _recentlySearched;
      if (suggestions === void 0) {
        suggestions = {};
      }
      if (recentlySearched === void 0) {
        recentlySearched = [];
      }
      var _this$state$value = _this.state.value,
        value = _this$state$value === void 0 ? '' : _this$state$value;
      var formattedSuggestions = _this.updateSuggestionsFormatting(suggestions);
      var formattedRecentSearchSuggestions = _this.formatSuggestions(value.trim(), recentlySearched);
      var updatedSuggestions = [];
      if (formattedSuggestions != null && formattedSuggestions.length) {
        updatedSuggestions.push({
          title: '',
          suggestions: formattedSuggestions
        });
      }
      if ((_recentlySearched = recentlySearched) != null && _recentlySearched.length) {
        updatedSuggestions.push({
          title: _this.props.labels.recentlySearched,
          suggestions: formattedRecentSearchSuggestions
        });
      }
      return updatedSuggestions;
    };
    _this.renderSectionTitle = function (section) {
      if (section === void 0) {
        section = {};
      }
      return section.title && section.suggestions && section.suggestions.length ? _react.default.createElement("strong", null, section.title) : '';
    };
    _this.getSectionSuggestions = function (section) {
      if (section === void 0) {
        section = {};
      }
      return section.suggestions || [];
    };
    _this.handleShopCategoryClick = function (e) {
      e.preventDefault();
      var _this$state2 = _this.state,
        suggestions = _this$state2.suggestions,
        searchQuery = _this$state2.value;
      var viewAllLabel = _this.props.labels.viewAllLabel;
      var suggestionsInfo = (0, _lodash.get)(suggestions, ['suggestions'], []);
      var value = (0, _lodash.get)(suggestionsInfo, ['0']);
      _this.setState({
        selectedCategory: SHOP
      });
      var id = e.currentTarget.id;
      var isShopLink = id === 'shop-option';
      _this.handleAnalyticsForSearchBar(searchQuery, SEARCH_LINK_TYPE.LINK, SHOP, (0, _common.getTernaryCondition)(isShopLink, SEARCH_TYPE.SKU_FAMILY, SEARCH_TYPE.TOP_RESULTS), (0, _common.getTernaryCondition)(isShopLink, value, viewAllLabel));
      return _this.handleSuggestionSelected(e, {
        suggestionValue: value
      });
    };
    _this.handleThumbnailClick = function (e) {
      var _this$state3 = _this.state,
        suggestions = _this$state3.suggestions,
        value = _this$state3.value;
      var _this$updateSuggestio = _this.updateSuggestionsObject(suggestions),
        suggestionCategory = _this$updateSuggestio.suggestionCategory;
      var category = suggestionCategory[e.index].category || '';
      var contentType = suggestionCategory[e.index].contenttype || '';
      var suggestionsInfo = (0, _lodash.get)(suggestions, ['suggestions'], []);
      var key = (0, _lodash.get)(suggestionsInfo, ['0']);
      var suggestion = {
        key: key,
        category: category,
        contentType: contentType,
        type: FACET,
        value: key
      };
      _this.handleAnalyticsForSearchBar(value, SEARCH_LINK_TYPE.IMAGE, category, SEARCH_TYPE.SKU_FAMILY, contentType);
      return _this.handleSuggestionSelected(e, {
        suggestionValue: key,
        suggestion: suggestion
      });
    };
    _this.getThumbnailImages = function (suggestionCategory) {
      return suggestionCategory.map(function (template) {
        return _this.mapTemplateToElement(template);
      });
    };
    _this.mapTemplateToElement = function (template) {
      var url = template.category_thumbnail !== 'null' ? template.category_thumbnail : _this.props.noThumbnailImage;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: "image-thumbnails-container__image",
        style: {
          backgroundImage: "url(" + url + ")"
        },
        "data-locator": "search-bar-thumbnails-image-content-type-image"
      }), _react.default.createElement("span", {
        className: "search-image-thumbnails-image-text",
        "data-locator": "search-bar-thumbnails-image-content-type"
      }, _react.default.createElement(_reactEllipsisText.default, {
        text: template.contenttype,
        length: 12
      })));
    };
    _this.handleViewAll = function () {
      var viewAllLabel = _this.props.labels.viewAllLabel;
      return _react.default.createElement("a", {
        onClick: _this.handleShopCategoryClick,
        href: "#",
        className: "cmp-sku-list-top-result__view-all",
        "data-locator": "search-bar-top-results-view-all"
      }, _react.default.createElement(_reactSvg.ReactSVG, {
        src: _this.props.multipleIconUrl,
        "data-locator": "search-bar-top-results-view-all-icon"
      }), _react.default.createElement("span", null, viewAllLabel));
    };
    _this.updateSuggestionsObject = function (suggestionsObject) {
      var suggestionsInfo = (0, _lodash.get)(suggestionsObject, 'facets', []);
      var suggestionCategory = _this.handleCategoryShop((0, _lodash.get)(suggestionsObject, 'facets', []));
      var topResultsData = (0, _lodash.get)(suggestionsObject, 'docs', []);
      var suggestionsDetails = (0, _lodash.get)(suggestionsObject, 'suggestions', []);
      return {
        topResultsData: topResultsData,
        suggestionCategory: suggestionCategory,
        suggestionsInfo: suggestionsInfo,
        suggestionsDetails: suggestionsDetails
      };
    };
    _this.renderMobileSearchHeader = function () {
      var _this$props = _this.props,
        _this$props$labels = _this$props.labels,
        search = _this$props$labels.search,
        clear = _this$props$labels.clear,
        iconClear = _this$props.iconClear;
      return _react.default.createElement("div", {
        className: "mobile-header-search-bar__title"
      }, _react.default.createElement("span", null, search), _react.default.createElement("button", {
        "aria-label": clear,
        onClick: function onClick(e) {
          return _this.handleSearchValueClear(e);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: "mobile-clear-icon",
        "data-locator": "mobile-search-clear-icon"
      }, _react.default.createElement(_reactSvg.ReactSVG, {
        "aria-hidden": "true",
        src: iconClear
      })));
    };
    _this.renderSearchContainer = function (children) {
      var _this$state4 = _this.state,
        suggestions = _this$state4.suggestions,
        isDesktop = _this$state4.isDesktop;
      var _this$updateSuggestio2 = _this.updateSuggestionsObject(suggestions),
        suggestionCategory = _this$updateSuggestio2.suggestionCategory,
        topResultsData = _this$updateSuggestio2.topResultsData;
      var _this$props$labels2 = _this.props.labels,
        inLabel = _this$props$labels2.in,
        partnumberLabel = _this$props$labels2.partnumberLabel,
        topResultsLabel = _this$props$labels2.topResultsLabel;
      var shopCategoryLength = suggestionCategory == null ? void 0 : suggestionCategory.length;
      var isShopCategory = shopCategoryLength > 0 && isDesktop;
      var thumbnailsWidth = 613;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: "search-image-thumbnails-wrapper"
      }, isShopCategory && _react.default.createElement("div", {
        className: "search-image-thumbnails-container"
      }, _react.default.createElement("div", {
        className: "search-bar-category",
        role: "option",
        id: "shop-option",
        onClick: _this.handleShopCategoryClick,
        "data-locator": "search-bar-shop-category"
      }, inLabel, _react.default.createElement("span", {
        className: "white-text"
      }, "_"), _react.default.createElement("strong", null, suggestionCategory[0].category)), (suggestionCategory == null ? void 0 : suggestionCategory.length) && _react.default.createElement(_ImageThumbnails.default, {
        items: _this.getThumbnailImages(suggestionCategory),
        onItemClick: _this.handleThumbnailClick,
        width: thumbnailsWidth
      })), children), isShopCategory && _react.default.createElement("div", {
        className: "search-top-results-wrapper",
        "data-locator": "search-bar-top-results-section",
        role: "listbox",
        id: "listbox-top-results"
      }, _react.default.createElement("h4", {
        "data-locator": "search-bar-top-results-section-heading"
      }, topResultsLabel), _react.default.createElement(_HeaderTopResults.default, {
        data: topResultsData,
        partNumberLabel: partnumberLabel,
        isEProc: _this.props.isEProc,
        handleAnalyticsForTopResults: _this.handleAnalyticsForTopResults
      }), _this.handleViewAll()));
    };
    _this.renderSuggestionsContainer = function (_ref) {
      var containerProps = _ref.containerProps,
        children = _ref.children;
      containerProps.className += ' header-search-bar-autosuggest-container ';
      var _this$state5 = _this.state,
        suggestions = _this$state5.suggestions,
        recentlySearched = _this$state5.recentlySearched;
      var isMobile = _this.props.isMobile;
      var _this$updateSuggestio3 = _this.updateSuggestionsObject(suggestions),
        suggestionsDetails = _this$updateSuggestio3.suggestionsDetails;
      return _react.default.createElement("div", containerProps, suggestionsDetails && suggestionsDetails.length > 0 && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: isMobile ? 'mobile-header-search-bar' : 'header-search-bar'
      }, isMobile && _this.renderMobileSearchHeader(), _this.renderSearchContainer(children))), suggestionsDetails && suggestionsDetails.length === 0 && recentlySearched && recentlySearched.length > 0 && _react.default.createElement("div", {
        className: isMobile ? 'mobile-header-search-bar' : 'header-search-bar'
      }, isMobile && _this.renderMobileSearchHeader(), children));
    };
    _this.renderAutoSuggest = function () {
      var _this$state6 = _this.state,
        placeholder = _this$state6.placeholder,
        value = _this$state6.value,
        _this$state6$checkOve = _this$state6.checkOverlay,
        checkOverlay = _this$state6$checkOve === void 0 ? false : _this$state6$checkOve,
        _this$state6$searchRe = _this$state6.searchRequested,
        searchRequested = _this$state6$searchRe === void 0 ? false : _this$state6$searchRe,
        _this$state6$suggesti = _this$state6.suggestions,
        suggestions = _this$state6$suggesti === void 0 ? {} : _this$state6$suggesti,
        _this$state6$recently = _this$state6.recentlySearched,
        recentlySearched = _this$state6$recently === void 0 ? [] : _this$state6$recently;
      var inputProps = {
        placeholder: placeholder,
        value: value,
        onChange: _this.handleSearchValueChange,
        onKeyPress: _this.handleSearchValuePress,
        onBlur: _this.handleSearchValueBlur,
        'aria-label': _this.props.labels.searchBox || ''
      };
      var formattedSuggestions = _this.transformSuggestionObject(suggestions, recentlySearched);
      if (searchRequested && checkOverlay) {
        _this.displayOverlayDebounce({});
      }
      return _react.default.createElement(_AutoSuggestWrapper.default, (0, _extends2.default)({
        ref: function ref(autosuggest) {
          if (autosuggest !== null) {
            _this.autosuggest = autosuggest;
          }
        },
        renderSuggestionsContainer: _this.renderSuggestionsContainer,
        multiSection: true,
        suggestions: formattedSuggestions,
        onSuggestionsFetchRequested: _this.handleSuggestionsFetchRequestedDebounce,
        onSuggestionsClearRequested: _this.onSuggestionsClearRequested,
        onSuggestionSelected: _this.handleSuggestionSelected,
        getSuggestionValue: _this.getSuggestionValueCallback,
        renderSuggestion: _this.renderSuggestionCallback,
        renderSectionTitle: _this.renderSectionTitle,
        getSectionSuggestions: _this.getSectionSuggestions
      }, {
        shouldRenderSuggestions: function shouldRenderSuggestions() {
          return true;
        }
      }, {
        focusInputOnSuggestionClick: !_this.props.isMobile,
        inputProps: inputProps
      }));
    };
    _this.renderHideClearIcon = function (iconClear) {
      var value = _this.state.value;
      return value ? _this.renderClearIcon(iconClear) : _react.default.createElement(_react.default.Fragment, null);
    };
    _this.renderClearIcon = function (iconClear) {
      return _react.default.createElement("button", {
        "aria-label": _this.props.labels.clear,
        onClick: function onClick(e) {
          return _this.handleClearIconClick(e);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: "clear-icon",
        "data-locator": "search-bar-clear-button"
      }, _react.default.createElement(_reactSvg.ReactSVG, {
        src: iconClear,
        className: "cmp-search-bar__icons-clear",
        "data-locator": "search-bar-clear-icon"
      }));
    };
    _this.renderSearchIcon = function (iconSearch) {
      return _react.default.createElement("button", {
        "aria-label": _this.props.labels.search,
        onClick: function onClick(e) {
          return _this.handleSearchIconClick(e);
        },
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: "search-icon",
        "data-locator": "search-bar-search-button"
      }, _react.default.createElement(_reactSvg.ReactSVG, {
        "aria-hidden": "true",
        src: iconSearch,
        className: "cmp-search-bar__icons-search",
        "data-locator": "search-bar-search-icon"
      }));
    };
    _this.handleViewChange = function () {
      var _this$props2 = _this.props,
        placeholderDesktop = _this$props2.placeholderDesktop,
        placeholderMobile = _this$props2.placeholderMobile;
      var placeHolder = _screenSizes.default.isMobile() ? placeholderMobile : placeholderDesktop;
      _this.setState({
        placeholder: placeHolder,
        isDesktop: _screenSizes.default.isDesktop()
      });
    };
    _this.handleAutosuggestClick = function (e) {
      if (Array.from(e.target.classList).find(function (element) {
        return element === 'react-autosuggest__input--focused';
      })) {
        _this.addSearchBarFocusCss();
      }
    };
    _this.handleSearchValuePress = function (e) {
      if (e.key !== 'Enter') return;
      var _this$state7 = _this.state,
        value = _this$state7.value,
        selectedCategory = _this$state7.selectedCategory;
      if (value.length !== 0) {
        _this.handleAnalyticsForSearchBar(value, SEARCH_LINK_TYPE.ICON, selectedCategory, SEARCH_TYPE.SEARCH_ICON);
        _this.handleSuggestionSelected(e, {
          suggestionValue: value
        });
      }
    };
    _this.handleSearchIconClick = function (e) {
      var _this$state8 = _this.state,
        value = _this$state8.value,
        selectedCategory = _this$state8.selectedCategory;
      if (value.length !== 0) {
        _this.handleAnalyticsForSearchBar(value, SEARCH_LINK_TYPE.ICON, selectedCategory, SEARCH_TYPE.SEARCH_ICON);
        _this.handleSuggestionSelected(e, {
          suggestionValue: value
        });
      }
    };
    _this.handleAnalyticsForSearchBar = function (searchQuery, linkType, searchCategory, searchType, linkName, searchContentType) {
      if (linkName === void 0) {
        linkName = '';
      }
      if (searchContentType === void 0) {
        searchContentType = '';
      }
      var analyticsData = {
        searchQuery: searchQuery,
        linkType: linkType,
        searchCategory: searchCategory,
        searchType: searchType,
        linkName: linkName
      };
      if (searchContentType) {
        analyticsData.searchContentType = searchContentType;
      }
      _this.props.searchBarInteraction(analyticsData);
    };
    _this.handleAnalyticsForTopResults = function (skucode) {
      var value = _this.state.value;
      _this.handleAnalyticsForSearchBar(value, SEARCH_LINK_TYPE.LINK, 'Shop', SEARCH_TYPE.TOP_RESULTS, skucode);
    };
    _this.handleClearIconClick = function () {
      _this.inputElement.focus();
      _this.addSearchBarFocusCss();
      _this.setState({
        value: '',
        suggestions: {},
        openOverlay: !!_this.state.recentlySearched.length
      }, function () {
        return !_this.state.recentlySearched.length && _this.removeCssOverridesForSearchBody();
      });
    };
    _this.handleSearchValueChange = function (event, _ref2) {
      var newValue = _ref2.newValue;
      if (newValue.length === 0 && !_this.state.recentlySearched.length) {
        // this will prevent white space from appearing below the search bar
        // as the user backspaces and deletes all of the characters
        _this.removeCssOverridesForSearchBar();
      }
      _this.setState({
        value: newValue
      }, function () {
        if (newValue.length === 0) {
          // the user has manually cleared the search bar so need to update the state
          _this.setState({
            suggestions: {},
            openOverlay: !!_this.state.recentlySearched.length || false,
            searchCategory: '',
            searchContentType: ''
          }, function () {
            return !(!!_this.state.recentlySearched.length || false) && _this.removeCssOverridesForSearchBody();
          });
        }
      });
    };
    _this.handleSearchValueBlur = function () {
      return _this.removeSearchBarFocusCss();
    };
    _this.handleSearchValueClear = function (event) {
      _this.autosuggest.onSuggestionsClearRequested();
    };
    _this.handleSuggestionsDisplay = function (_ref3) {
      var _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? '' : _ref3$reason;
      var _this$state9 = _this.state,
        value = _this$state9.value,
        suggestions = _this$state9.suggestions,
        openOverlay = _this$state9.openOverlay;
      var _this$props3 = _this.props,
        minSearchCharacters = _this$props3.minSearchCharacters,
        recentlySearched = _this$props3.recentlySearched;
      var overlay = value.length >= minSearchCharacters && (0, _lodash.get)(suggestions, ['suggestions'], []).length !== 0 || recentlySearched.length !== 0;
      if (value.length >= minSearchCharacters) _this.getSearchValue();
      _this.setState({
        autoSuggestReason: reason
      });
      if (openOverlay === overlay) return;
      if (overlay) {
        _this.addCssOverridesForSearchBar();
        _this.addCssOverridesForSearchBody();
      }
      _this.setState({
        openOverlay: overlay
      }, function () {
        if (!overlay) {
          _this.removeCssOverridesForSearchBar();
          _this.removeCssOverridesForSearchBody();
        }
      });
    };
    _this.displayOverlay = function (overlay) {
      if (overlay === void 0) {
        overlay = true;
      }
      _this.addCssOverridesForSearchBar();
      _this.addCssOverridesForSearchBody();
      _this.setState({
        openOverlay: overlay,
        checkOverlay: false,
        searchRequested: false
      });
    };
    _this.onSuggestionsClearRequested = function () {
      _this.removeCssOverridesForSearchBar(); // delay updating the state so the onClick of the X icon is not ignored
      // otherwise, the event handler for the X icon will never execute

      setTimeout(function () {
        return _this.setState({
          openOverlay: false,
          suggestions: {},
          recentlySearched: [],
          checkOverlay: false,
          searchRequested: false,
          autoSuggestReason: REASON_SUGGESTIONS_CLEARED,
          searchCategory: '',
          searchContentType: ''
        }, function () {
          return _this.removeCssOverridesForSearchBody();
        });
      }, 125);
    };
    _this.getSuggestionValueCallback = function (suggestion) {
      return suggestion.key;
    };
    _this.renderSuggestionCallback = function (suggestion) {
      return _react.default.createElement("div", null, suggestion.value);
    };
    _this.handleFacets = function (facetsInfo) {
      var facets = [];
      var lastCategory;
      var isDesktop = _this.state.isDesktop;
      facetsInfo.forEach(function (facet) {
        if (facets.length < MAX_FACETS && lastCategory !== facet.category && (facet.category !== SHOP && isDesktop || !isDesktop)) {
          facets.push(facet);
          lastCategory = facet.category;
        }
      });
      return facets;
    };
    _this.handleCategoryShop = function (facetsInfo) {
      return facetsInfo.filter(function (facet) {
        return facet.category === SHOP;
      });
    };
    _this.createStrippedFacetName = function (facetName) {
      return facetName.replace(/[\W_]+/g, '').toLowerCase();
    };
    _this.handleSuggestionSelected = function (event, _ref4) {
      var suggestionValue = _ref4.suggestionValue,
        suggestion = _ref4.suggestion,
        sectionIndex = _ref4.sectionIndex;
      var searchPath = _this.props.searchPath;
      var _this$state10 = _this.state,
        searchCategory = _this$state10.searchCategory,
        searchContentType = _this$state10.searchContentType;
      var _this$state11 = _this.state,
        selectedCategoryValue = _this$state11.selectedCategory,
        value = _this$state11.value,
        suggestions = _this$state11.suggestions;
      if (suggestion && suggestion.type === FACET) {
        searchCategory = suggestion.category;
        searchContentType = _this.createStrippedFacetName(suggestion.contentType);
      }
      _this.removeCssOverridesForSearchBar();
      var suggestionsInfo = (0, _lodash.get)(suggestions, ['suggestions'], []);
      if (typeof sectionIndex !== 'undefined') {
        var isSuggestion = sectionIndex === 0 && suggestionsInfo.length > 0;
        var searchType = (0, _common.getTernaryCondition)(isSuggestion, SEARCH_TYPE.SEARCH_SUGGESIONS, SEARCH_TYPE.RECENTLY_SEARCHED);
        var contentType = '';
        if (searchContentType) {
          contentType = suggestion.contentType;
        }
        _this.handleAnalyticsForSearchBar(value, SEARCH_LINK_TYPE.LINK, searchCategory || selectedCategoryValue, searchType, suggestionValue, contentType);
      }
      _this.setState({
        value: suggestionValue,
        suggestions: {},
        openOverlay: false,
        searchRequested: false,
        suggestionSelected: true,
        recentlySearched: [],
        searchCategory: searchCategory,
        searchContentType: searchContentType
      }, function () {
        var searchObject = {
          keyword: _this.state.value
        };
        var category = _this.state.searchCategory;
        var selectedCategory = _this.state.selectedCategory;
        if (!category && selectedCategory !== ALL) {
          category = selectedCategory;
        }
        searchObject = category ? (0, _extends2.default)({}, searchObject, {
          category: category
        }) : searchObject;
        searchObject = _this.state.searchContentType ? (0, _extends2.default)({}, searchObject, {
          content_type: _this.state.searchContentType
        }) : searchObject;
        _this.removeCssOverridesForSearchBody();
        _this.setUrlParameter(searchObject, searchPath);
      });
    };
    _this.setUrlParameter = function (searchObject, searchPath) {
      var parameters = _this.buildParameters(searchObject || {});
      _this.props.searchBarSubmit({
        searchTerm: parameters.keyword
      });
      var querystring = _this.stringifyParameters(parameters);
      window.location.href = searchPath + "?" + querystring;
    };
    _this.buildParameters = function (searchObject) {
      if (searchObject === void 0) {
        searchObject = {};
      }
      var _this$state$parameter2 = _this.state.parameterDefaults,
        keyword = _this$state$parameter2.keyword,
        sort = _this$state$parameter2.sort,
        mostRelevant = _this$state$parameter2.mostRelevant;
      var searchKey = (0, _lodash.get)(searchObject, 'keyword', keyword);
      var searchSort = searchKey === keyword ? sort : mostRelevant;
      return (0, _extends2.default)({}, searchObject, {
        keyword: searchKey,
        sort: searchSort
      });
    };
    _this.stringifyParameters = function (parameters) {
      return Object.keys(parameters).length !== 0 ? Object.keys(parameters).map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(parameters[key]);
      }).join('&') : '';
    };
    _this.getOverridesClass = function (selectedClass) {
      var isMobile = _this.props.isMobile;
      return isMobile ? searchNoScrollClassName : selectedClass;
    };
    _this.addCssOverridesForSearchBar = function () {
      return document.getElementsByTagName('body')[0].classList.add(_this.getOverridesClass(cssOverridesForSearchBar));
    };
    _this.removeCssOverridesForSearchBar = function () {
      return document.getElementsByTagName('body')[0].classList.remove(_this.getOverridesClass(cssOverridesForSearchBar));
    };
    _this.addCssOverridesForSearchBody = function () {
      return document.getElementsByTagName('body')[0].classList.add(_this.getOverridesClass(cssOverridesForSearchBody));
    };
    _this.removeCssOverridesForSearchBody = function () {
      return document.getElementsByTagName('body')[0].classList.remove(_this.getOverridesClass(cssOverridesForSearchBody));
    };
    _this.getFacetStructure = function (contentType, category) {
      var labels = _this.props.labels;
      return _react.default.createElement("span", {
        className: "formatted-facet"
      }, labels.in, _react.default.createElement("span", {
        className: "white-text"
      }, "_"), _react.default.createElement("strong", null, contentType), _react.default.createElement("span", {
        className: "white-text"
      }, "_"), labels.in, _react.default.createElement("span", {
        className: "white-text"
      }, "_"), category);
    };
    _this.formatFacets = function (facets, suggestion) {
      if (suggestion === void 0) {
        suggestion = '';
      }
      return facets.map(function (facet) {
        var category = (0, _lodash.get)(facet, 'category', '');
        var contentType = (0, _lodash.get)(facet, 'contenttype', '');
        return {
          key: suggestion,
          category: category,
          contentType: contentType,
          type: FACET,
          value: _this.getFacetStructure(contentType, category)
        };
      });
    };
    _this.formatSuggestions = function (term, suggestions) {
      return suggestions ? suggestions.map(function (suggestion) {
        return {
          key: suggestion,
          type: SUGGESTION,
          value: _react.default.createElement("span", {
            className: "formatted-suggestion"
          }, _this.formatSuggestion(term, suggestion).reduce(function (accumulator, currentValue) {
            return _react.default.createElement(_react.default.Fragment, null, accumulator, currentValue);
          }))
        };
      }) : [];
    };
    _this.formatSuggestion = function (term, suggestion) {
      // wrap the matching characters with a pipe |
      // wrap the matching characters with a pipe | escape all possible regex special characters
      var reg = /([.?*+^$[\]\\(){}|-])/g;
      var escapedTerm = term.replace(reg, '\\$1');
      var delimittedSuggestion = suggestion.replace(new RegExp("\\b" + escapedTerm, 'ig'), "|" + term + "|"); // convert string to array split with pipe |
      // this will isolate the matching characters into it's own location in the array

      var words = delimittedSuggestion.split('|').filter(function (word) {
        return word !== '';
      }); // create a new array that will wrap the matching characters into a styled span to highlight
      // non-matching characters will simply display inside a span element

      return words.map(function (item) {
        return item.toLowerCase() === term.toLowerCase() ? _this.formatMatchingWord(item, term.length) : _this.formatNonMatchingWords(item);
      });
    };
    _this.formatMatchingWord = function (word, termLength) {
      return _react.default.createElement("span", {
        className: "emphasis-matching-characters"
      }, word.substring(0, termLength));
    };
    _this.formatNonMatchingWords = function (value) {
      // wrap spaces with a pipe | & split into an array
      var words = value.replace(/\s/g, '| |').split('|').filter(function (word) {
        return word !== '';
      }); // use an underscore instead of a space to preserve the space in the flex row
      // this is needed because IE doesn't handle white-space: pre-wrap the same as other browsers
      // therefore, pre-wrap is not need since we are replacing the space with an underscore

      var formattedWords = words.map(function (word, index) {
        var key = "word-text" + word + index;
        return word === ' ' ? _react.default.createElement("span", {
          className: "white-text",
          key: key
        }, "_") : _react.default.createElement("span", {
          key: key
        }, word);
      });
      return formattedWords.reduce(function (accumulator, currentValue) {
        return _react.default.createElement(_react.default.Fragment, null, accumulator, currentValue);
      });
    };
    _this.addSearchBarFocusCss = function () {
      return _this.searchBarRef.current.classList.add(searchBarFocusClassName);
    };
    _this.removeSearchBarFocusCss = function () {
      return _this.searchBarRef.current.classList.remove(searchBarFocusClassName);
    };
    _this.handleCategoriesClick = function (event) {
      _this.setState({
        selectedCategory: event.target.value
      });
    };
    _this.renderCategories = function () {
      var labels = _this.props.labels;
      var categoryOptions = [{
        value: 'All',
        label: labels.all
      }, {
        value: 'Education',
        label: labels.education
      }, {
        value: 'Events',
        label: labels.events
      }, {
        value: 'Library',
        label: labels.library
      }, {
        value: 'Support Library',
        label: labels.support
      }, {
        value: 'Shop',
        label: labels.shop
      }];
      return _react.default.createElement("div", {
        className: "category-dropdown"
      }, _react.default.createElement(_Select.default, {
        id: "dropdown-category",
        name: "category-dropdown",
        options: categoryOptions,
        className: "search-dropdown select-category-dropdown",
        value: _this.state.selectedCategory,
        onChange: _this.handleCategoriesClick,
        elementLocator: "dropdown-category-dropdown",
        ariaLabel: "search category dropdown",
        isDynamicWidth: true
      }));
    };
    _this.getOverLay = function () {
      var openOverlay = _this.state.openOverlay;
      return _react.default.createElement(_overlay.default, {
        isOpen: openOverlay,
        onClickAction: _this.onSuggestionsClearRequested
      });
    };
    _this.inputElement = null;
    _this.searchBarRef = _react.default.createRef();
    var _this$props4 = _this.props,
      _onSearchRequest = _this$props4.onSearchRequest,
      _placeholderMobile = _this$props4.placeholderMobile,
      _placeholderDesktop = _this$props4.placeholderDesktop,
      defaultConfig = _this$props4.defaultConfig,
      isEProc = _this$props4.isEProc;
    _this.state = {
      value: '',
      onSearchRequest: _onSearchRequest,
      suggestions: {},
      recentlySearched: [],
      openOverlay: false,
      autoSuggestReason: '',
      placeholder: !_screenSizes.default.isDesktop() ? _placeholderMobile : _placeholderDesktop,
      suggestionSelected: false,
      parameterDefaults: {
        rows: defaultConfig.rows || MAX_TOP_RESULTS,
        keyword: defaultConfig.keyword || '*:*',
        mostRecent: defaultConfig.mostRecent || 'most-recent',
        isoCode: defaultConfig.isoCode || 'en',
        mostRelevant: defaultConfig.mostRelevant || 'most-relevant'
      },
      searchCategory: '',
      searchContentType: '',
      selectedCategory: isEProc ? SHOP : ALL,
      isDesktop: _screenSizes.default.isDesktop()
    };
    _this.handleSuggestionsFetchRequestedDebounce = (0, _lodash.debounce)(_this.handleSuggestionsDisplay, 250);
    _this.handleWindowResizeDebounce = (0, _lodash.debounce)(_this.handleViewChange, 150);
    _this.displayOverlayDebounce = (0, _lodash.debounce)(_this.displayOverlay, 150);
    return _this;
  }
  SearchBar.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var newState = null;
    if (!state.placeholder) {
      newState = (0, _extends2.default)({}, newState, {
        placeholder: !_screenSizes.default.isDesktop() ? props.placeholderMobile : props.placeholderDesktop
      });
    }
    if (!state.suggestionSelected && state.autoSuggestReason !== REASON_SUGGESTIONS_CLEARED) {
      var checkOverlay = !(0, _lodash.isEqual)(state.recentlySearched, props.recentlySearched);
      newState = (0, _extends2.default)({}, newState, {
        recentlySearched: props.recentlySearched
      });
      newState = state.value && state.value.length >= props.minSearchCharacters ? (0, _extends2.default)({}, newState, {
        suggestions: props.suggestions,
        checkOverlay: checkOverlay || !(0, _lodash.isEqual)(state.suggestions, props.suggestions)
      }) : (0, _extends2.default)({}, newState, {
        checkOverlay: checkOverlay
      });
    }
    if (props.defaultConfig !== state.defaultConfig) {
      newState = (0, _extends2.default)({}, newState, {
        parameterDefaults: props.defaultConfig
      });
    }
    if (props.isEProc && state.selectedCategory !== SHOP) {
      newState = (0, _extends2.default)({}, newState, {
        selectedCategory: SHOP
      });
    }
    return newState;
  } // Transform the list of suggestions and recentlySearches, into structure to be shown on browser
  ;

  var _proto = SearchBar.prototype;
  _proto.updateSuggestionsFormatting = function updateSuggestionsFormatting(suggestionsObject) {
    var value = this.state.value;
    var minSearchCharacters = this.props.minSearchCharacters;
    if (value.length >= minSearchCharacters) {
      var formatFacets = this.formatFacets(this.handleFacets((0, _lodash.get)(suggestionsObject, 'facets', [])), (0, _lodash.get)(suggestionsObject, ['suggestions', '0'], ''));
      var suggestionsList = this.formatSuggestions(value.trim(), (0, _lodash.get)(suggestionsObject, 'suggestions', []));
      return [].concat(suggestionsList.splice(0, 1), formatFacets, suggestionsList);
    }
    return [];
  };
  _proto.render = function render() {
    var _this$props5 = this.props,
      iconSearch = _this$props5.iconSearch,
      iconClear = _this$props5.iconClear,
      disableOverlay = _this$props5.disableOverlay,
      isEProc = _this$props5.isEProc,
      isMobile = _this$props5.isMobile,
      id = _this$props5.id;
    var searchBarStyle = isEProc ? 'cmp-header-search-bar-eproc' : 'cmp-header-search-bar-default';
    return _react.default.createElement(_react.default.Fragment, null, !disableOverlay && !isMobile && this.getOverLay(), !isEProc && !isMobile ? this.renderCategories() : '', _react.default.createElement("div", {
      ref: this.searchBarRef,
      className: "cmp-search-bar " + searchBarStyle,
      id: id,
      "data-locator": "search-bar-dropdown-" + id,
      onClick: this.handleAutosuggestClick
    }, this.renderAutoSuggest(), _react.default.createElement("div", {
      className: "cmp-search-bar__icons"
    }, this.renderHideClearIcon(iconClear), this.renderSearchIcon(iconSearch))));
  };
  return SearchBar;
}(_react.Component);
SearchBar.defaultProps = {
  iconClear: '',
  iconSearch: '',
  searchPath: '',
  minSearchCharacters: 1,
  onSearchRequest: function onSearchRequest() {
    /* default onSearchRequest handler */
  },
  searchBarSubmit: function searchBarSubmit() {
    /* default searchBarSubmit handler */
  },
  placeholderMobile: '',
  placeholderDesktop: '',
  suggestions: {},
  recentlySearched: [],
  defaultConfig: {},
  labels: {},
  disableOverlay: false,
  multipleIconUrl: '',
  noThumbnailImage: '/content/dam/waters/en/brand-assets/thumbnails/product-thumbnail.png',
  isEProc: false,
  searchBarInteraction: function searchBarInteraction() {
    /* default search bar handler */
  }
};
var _default = SearchBar;
exports.default = _default;
module.exports = exports["default"];